<template>
  <div class="echarts-warp dn-content-bg">
    <div class="echart-content">
      <div class="iconlocal" v-if="showAddBtn">
        <i class="el-icon-office-building" @click="clickoTherAdd"></i>
      </div>
      <div class="echarts-title">{{ title }}</div>
      <div
        :id="getId"
        :style="{ width: '100%', height: height + 'px' }"
        v-resize="resize"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "图表标题",
    },
    timeTitle: {
      type: String,
      default: "",
    },
    unit: {
      type: String,
      default: "",
    },
    max: {
      type: String,
      default: "",
    },
    //不规则的x轴
    isIrregularity: {
      type: Boolean,
      default: true,
    },
    showAddBtn: {
      type: Boolean,
      default: false,
    },
    activeName: {
      type: String,
      default: "ele",
    },
    /**
     * 是否显示最大值的点
     */
    showMaxPoint: {
      type: Boolean,
      default: false,
    },
    /**
     * 是否显示最小值的点
     */
    showMinPoint: {
      type: Boolean,
      default: false,
    },
    /**
     * 线   单个图表的时候才起效
     */
    markLine: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    data() {
      let vm = this;
      if (vm.data.length == 0 || vm.data.length == 1) {
        vm.drawLine();
      } else {
        vm.drawLines();
      }
    },
  },
  data() {
    return {
      id: "",
      myChart: null,
      isShow: false,
      height: 400,
    };
  },
  computed: {
    getId() {
      let vm = this;
      vm.id =
        "chart" +
        (Math.random() * 10000000).toString(16).substr(0, 4) +
        "-" +
        new Date().getTime() +
        "-" +
        Math.random()
          .toString()
          .substr(2, 5);
      return vm.id;
    },
  },
  mounted() {
    let vm = this;
    if (vm.data.length == 0 || vm.data.length == 1) {
      vm.drawLine();
    } else {
      vm.drawLines();
    }
  },
  methods: {
    resize() {
      let vm = this;
      vm.myChart && vm.myChart.resize();
    },
    drawLine() {
      let vm = this;
      if (vm.data.length < 0) {
        return;
      }
      let obj = JSON.parse(JSON.stringify(vm.data[0]));
      let series = [],
        xAxis = {},
        yAxis = [];
      // 判断是不是不规则的时间
      if (vm.isIrregularity == false) {
        xAxis = {
          data: obj.xData,
          axisLine: {
            lineStyle: {
              color: "#666",
            },
          },
        };
      } else {
        xAxis = {
          type: "time",
          axisLine: {
            lineStyle: {
              color: "#666",
            },
          },
        };
      }
      let markPoint = {
        data: [],
      };
      //添加最大最小值的点
      if (vm.showMaxPoint)
        [markPoint.data.push({ type: "max", name: "最大值" })];
      if (vm.showMinPoint)
        [markPoint.data.push({ type: "min", name: "最大值" })];
      for (let index = 0; index < obj.data.length; index++) {
        let arr = obj.data[index];
        if (vm.isIrregularity == true) {
          for (let j = 0; j < arr.length; j++) {
            arr[j] = {
              value: [obj.xData[j], arr[j]],
            };
          }
        }
        let tempSeries = {
          name: obj.tip[index],
          type: "line",
          data: arr,
          markPoint: markPoint,
          markLine: vm.markLine,
        };
        if (this.activeName == "ele") {
          tempSeries.areaStyle = {
            color: "#78b1e9",
            opacity: "0.2",
          };
        }

        series.push(tempSeries);
      }
      if (vm.myChart == null) {
        vm.myChart = vm.$echarts.init(document.getElementById(vm.id));
      } else {
        vm.myChart.clear();
      }
      // 绘制图表
      let y = [
        {
          name: vm.unit,
          type: "value",
          scale: true,
          axisLine: {
            lineStyle: {
              color: "#666",
            },
          },
          max: function(value) {
            if (vm.markLine == null || vm.markLine.data.length == 0) {
              return (value.max * 1.1).toFixed(2);
            } else {
              if (vm.markLine.data[0].yAxis > value.max) {
                return (vm.markLine.data[0].yAxis * 1.1).toFixed(2);
              } else {
                return (value.max * 1.1).toFixed(2);
              }
            }
          },
          min: function(value) {
            if (
              vm.markLine == null ||
              vm.markLine.data.length == 1 ||
              vm.markLine.data.length == 0
            ) {
              return (value.min * 0.9).toFixed(2);
            } else {
              if (vm.markLine.data[1].yAxis < value.min) {
                return (vm.markLine.data[1].yAxis * 0.9).toFixed(2);
              } else {
                return (value.min * 0.9).toFixed(2);
              }
            }
          },
        },
      ];
      if (vm.max) {
        y[0].max = vm.max;
      }
      // 处理平均功率因数线颜色
      vm.markLine.lineStyle = {
        color: "#E62E4D",
      };
      vm.myChart.setOption({
        color: [
          "#0080FF",
          // "#d2b533",
          // "#fe3c00",
          // "#7928cb",
          // "#8eb2f0",
          // "#003690",
          // "#0db198",
          // "#9ff093"
        ],
        title: {
          text: obj.title.replace(/[\r\n]/g, ""),
          subtext: "查询时间：" + vm.timeTitle.replace(/[\r\n]/g, ""),
          left: "center",
        },
        tooltip: {
          trigger: "axis",
        },
        toolbox: {
          show: true,
          right: 20,
          feature: {
            saveAsImage: {},
            magicType: {
              type: ["line", "bar"],
            }, //切换为折线图，切换为柱状图
          },
        },
        grid: {
          left: "5%",
          right: "5%",
          top: "25%",
        },
        legend: {
          data: obj.tip,
          selected: obj.selected,
          left: "center",
          top: "12%",
          textStyle: {
            color: "#666",
          },
        },
        dataZoom: [
          {
            type: "inside",
            show: true,
            realtime: true,
          },
          {
            show: true,
            realtime: true,
            end: 100,
            type: "slider",
            width: "92%",
            left: "center",
          },
        ],
        xAxis: xAxis,
        yAxis: y,
        series: series,
      });
      vm.isShow = true;
      //屏幕变化刷新
      window.addEventListener("resize", function() {
        if (vm.myChart) {
          vm.myChart.resize();
        }
      });
    },
    clickoTherAdd() {
      this.$emit("clickoTherAdd");
    },
    drawLines() {
      let vm = this;
      let data = vm.data;
      //生成图表的grid
      let grid = [],
        xAxis = [],
        yAxis = [],
        series = [],
        title = [],
        obj = data[0];
      document.getElementById(vm.id).style.height = 280 * data.length + "px";
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        let top = 80 + 180 * index + 80 * index;
        grid.push({
          left: "5%",
          right: "5%",
          top: top + "px",
          height: "180px",
        });

        if (vm.isIrregularity == false) {
          xAxis.push({
            gridIndex: index,
            data: data[index].xData,
            axisLine: {
              lineStyle: {
                color: "#666",
              },
            },
          });
        } else {
          xAxis.push({
            gridIndex: index,
            type: "time",
            axisLine: {
              lineStyle: {
                color: "#666",
              },
            },
          });
        }
        yAxis.push({
          gridIndex: index,
          name: vm.unit,
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#666",
            },
          },
        });
        title.push({
          text: data[index].title.replace(/[\r\n]/g, ""),
          left: "center",
          top: top - 50 + "px",
        });
        for (let j = 0; j < data[index].data.length; j++) {
          const arr = data[index].data[j];

          if (vm.isIrregularity == true) {
            for (let t = 0; t < arr.length; t++) {
              arr[t] = {
                value: [data[index].xData[t], arr[t]],
              };
            }
          }
          series.push({
            xAxisIndex: index,
            yAxisIndex: index,
            name: obj.tip[j],
            type: "line",
            data: arr,
          });
        }
        series.push();
      }

      if (vm.myChart == null) {
        vm.myChart = vm.$echarts.init(document.getElementById(vm.id));
      } else {
        vm.myChart.clear();
      }
      vm.myChart.resize();
      // 绘制图表
      // {
      //     subtext: "查询时间：" + vm.timeTitle,
      //     left: "center"
      //   }
      console.log(xAxis);
      console.log(yAxis);
      vm.myChart.setOption({
        title: title,
        tooltip: {
          trigger: "axis",
        },
        grid: grid,
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {},
            magicType: {
              type: ["line", "bar"],
            }, //切换为折线图，切换为柱状图
          },
        },
        legend: {
          data: obj.tip,
          selected: obj.selected,
          x: "center",
          top: "0px",
          textStyle: {
            color: "#666",
          },
        },
        // dataZoom: [
        //   {
        //     show: true,
        //     realtime: true
        //   }
        // ],
        xAxis: xAxis,
        yAxis: yAxis,
        series: series,
      });
      vm.isShow = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.echarts-warp {
  width: 100%;
  padding: 14px;
  box-sizing: border-box;
  border-radius: 5px;
  border: 1px solid #dedcdc;
}
.echart-content {
  border-radius: 5px;
  border: 1px solid #dedcdc;
  overflow: hidden;
  position: relative;
}
.echarts-title {
  height: 34px;
  line-height: 34px;
  padding-left: 14px;
  // color: #fff;
  color: #333;
  // background: #1d6ce9;
}
.iconlocal {
  position: absolute;
  top: 40px;
  right: 110px;
  z-index: 999;
  i {
    cursor: pointer;
  }
}
.iconlocal:hover {
  cursor: pointer;
  color: #1d6ce9;
}
.chartbox {
  position: absolute;
  top: 35px;
}
</style>
